<template>
  <div></div>
</template>

<script>
export default {
  name: "HeaderMain"
};
</script>